// sweetalert2 (~160 KB) hanya hidup saat ada notifikasi, tapi impor statis di sini
// menaruhnya di chunk AWAL — berkas ini dirujuk AlertPlugin yang dipasang di main.js.
// Dimuat saat toast pertama dipanggil, lalu dipakai ulang (promise di-cache, jadi dua
// toast beruntun tidak mengunduh dua kali). Pemanggil tak berubah: `toast()` dari dulu
// mengembalikan promise.
import { takeRecentRef } from "@/utils/errorLog.mjs";

let toastPromise = null;

const loadToast = () => {
    if (!toastPromise) {
        toastPromise = import(/* webpackChunkName: "sweetalert2" */ "sweetalert2").then(
            ({ default: Swal }) =>
                Swal.mixin({
                    toast: true,
                    position: "bottom",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "custom-toast-popup", // Default class
                        title: "custom-toast-title", // Custom title class
                        icon: "custom-toast-icon", // Custom icon class
                    },
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    },
                })
        );
    }
    return toastPromise;
};

const alert = {
    async toast(icon, title) {
        const Toast = await loadToast();
        // Kode error ikut ditempel supaya tamu bisa menyebutkannya ("gagal ... (481523)").
        // Detail lengkapnya sudah terkirim diam-diam ke External Log dengan kode yang sama.
        // Hanya untuk toast gagal, dan hanya bila memang ada error dalam beberapa detik terakhir —
        // peringatan validasi murni di sisi klien tak punya kode dan memang tak perlu.
        const ref = icon === "error" || icon === "warning" ? takeRecentRef() : null;
        const message = title || "Default Message, Please contact admin!";
        return Toast.fire({
            icon: icon || "warning",
            title: ref ? `${message} (${ref})` : message,
            customClass: {
                popup: `custom-toast-popup ${icon}`, // Add dynamic icon class
                title: "custom-toast-title",
                icon: "custom-toast-icon",
            },
        });
    },
};

export default alert;
